import { memo } from 'react'

import {
	EuiFlexGroup,
	EuiFlexItem,
	EuiIcon,
	EuiText,
} from '@equipmentshare/ds2'

import { StarLineIcon } from '@equipmentshare/ds2-icons'

import Actions from './components/Actions'
import { InventoryLocationWithLabel } from 'hooks/inventory-location-search'
import { PermissionGrant } from '../../../../../graphql'

export type InventoryLocationProps = {
	inventoryLocation: InventoryLocationWithLabel,
	onEditLocation: ( inventoryLocation: InventoryLocationWithLabel ) => ( e: React.MouseEvent ) => void,
	onSetDefault: ( inventoryLocation: InventoryLocationWithLabel ) => ( e: React.MouseEvent ) => void,
	onDeleteLocation: ( inventoryLocation: InventoryLocationWithLabel ) => ( e: React.MouseEvent ) => void,
	onMoveLocation: ( inventoryLocation: InventoryLocationWithLabel ) => ( e: React.MouseEvent ) => void,
	onWarehouseSettings: ( inventoryLocation: InventoryLocationWithLabel ) => ( e: React.MouseEvent ) => void,
	userPermissions: PermissionGrant[],
  totalNumberOfInventories: number,
}

import styles from '../../inventoryLocations.module.css'

function InventoryLocation( { inventoryLocation, onEditLocation, onSetDefault, onDeleteLocation, onMoveLocation, onWarehouseSettings, userPermissions, totalNumberOfInventories }: InventoryLocationProps ) {
	return (
		<EuiFlexGroup
			justifyContent="spaceBetween"
			alignItems="center"
			direction="row"
			key={inventoryLocation.id}
			className={styles.childStoreContainer}
		>
			<EuiFlexItem grow>
				<EuiFlexGroup gutterSize="m">
					<EuiFlexItem grow={false}>
						<div style={{ width: '16px' }}>
							{ inventoryLocation.defaultLocation && (
								<EuiIcon
									type={StarLineIcon}
									aria-label="Main inventory"
								/>
							) }
						</div>
					</EuiFlexItem>
					<EuiFlexItem>
						<EuiText size="s">
							{inventoryLocation.name}
						</EuiText>
					</EuiFlexItem>
				</EuiFlexGroup>
			</EuiFlexItem>
			<EuiFlexItem grow={false}>
				<Actions
					inventoryLocation={inventoryLocation}
					onEdit={onEditLocation}
					onDelete={onDeleteLocation}
					onSetDefault={onSetDefault}
					onMove={onMoveLocation}
					onWarehouseSettings={onWarehouseSettings}
					userPermissions={userPermissions}
					totalNumberOfInventories={totalNumberOfInventories}
				/>
			</EuiFlexItem>
		</EuiFlexGroup>
	)
}

const MemoizedInventoryLocation = memo( InventoryLocation )
MemoizedInventoryLocation.displayName = 'InventoryLocation'

export default MemoizedInventoryLocation
